/**
 * @deprecated use hydrated from app/core/hydrationProvider to know whether we are still doing the initial first render of the component
 */
export const isClient = () => {
    return typeof window !== 'undefined';
};
